module.exports = __webpack_public_path__ + "media/images/trash_can_icon_white-8af5c5b1c6190ed439c043846b6681fe.svg";